module.exports = {
  apiKey: "AIzaSyDHhkViJz4D8DoE3oCXxKlAgAU7GWd9o54",
  authDomain: 'qr.rubbish.love',
  rubbishUrl: "https://qr.rubbish.love",
  databaseURL: "https://rubbishproduction-411a1.firebaseio.com",
  projectId: "rubbishproduction-411a1",
  storageBucket: "rubbishproduction-411a1.appspot.com",
  messagingSenderId: "397544748320",
  appId: "1:397544748320:web:23bd0e148d621dc9e89345"
};